import {
  useWSModal,
  WSControl,
  WSElement,
  WSForm,
  WSInputText
} from "@wingspanhq/fe-component-library";
import React from "react";
import * as Yup from "yup";
import { queriesComplianceEntities } from "@query";
import { validatorWebsite } from "../../../../../shared/validators/validatorWebsite";
import { LayoutFormEdit } from "./LayoutFormEdit";

type FormData = { website: string; noWebsite: boolean };

type Props = {
  onClose: () => void;
};

export const FormEditWebsite: React.FC<Props> = props => {
  const queryComplianceEntities =
    queriesComplianceEntities.listComplianceEntities.useQuery({});
  const primaryEntity = queryComplianceEntities.data?.data?.find(
    entity => !entity.subject
  );
  const [mutate, meta] =
    queriesComplianceEntities.updateComplianceEntity.useMutation({
      dependencies: [
        queriesComplianceEntities.listComplianceEntities.queryKeyBase
      ],
      onSuccess: props.onClose
    });

  const initialWebsite = primaryEntity?.websiteUrl;

  return (
    <WSForm<FormData>
      onSubmit={data => {
        if (!primaryEntity?.id) {
          return;
        }

        mutate({
          complianceEntityId: primaryEntity.id,
          complianceEntityUpdate: {
            websiteUrl: data.noWebsite ? "" : data.website
          }
        });
      }}
      defaultValues={{
        website: !initialWebsite ? "" : initialWebsite,
        noWebsite: !initialWebsite
      }}
      validationSchema={Yup.object({
        website: validatorWebsite,
        noWebsite: Yup.boolean()
          .nullable()
          .when("website", {
            is: (website: string) => !website,
            then: Yup.boolean()
              .nullable()
              .isTrue(
                "Please check the box if your business does not have a website"
              )
          })
      })}
    >
      <LayoutFormEdit
        isLoading={meta.isLoading}
        error={meta.error}
        onCancel={props.onClose}
      >
        <WSElement>
          <WSForm.Value name="noWebsite">
            {noWebsite => (
              <WSForm.Field
                mb="S"
                name="website"
                label="Business website (optional)"
                component={WSInputText}
                componentProps={{
                  disabled: noWebsite,
                  autoComplete: "url",
                  placeholder: "http://"
                }}
              />
            )}
          </WSForm.Value>

          <WSForm.Field
            name="noWebsite"
            component={WSControl}
            componentProps={{
              type: "checkbox",
              size: "S",
              label: "The business does not have a website"
            }}
          />
        </WSElement>
      </LayoutFormEdit>
    </WSForm>
  );
};

export const useModalEditWebsite = () =>
  useWSModal(FormEditWebsite, {
    title: "Business website",
    size: "S"
  });
